import { Box, Button, Dialog, DialogContent, Grid, Typography, useMediaQuery } from "@mui/material";
import WhiteInosio from "../../../icons/whiteinosio.svg";
import ConfirmationTick from "../../../icons/ConfirmationTick.svg"
import close from "../../../icons/close.svg";
import React from "react";

interface ConfirmCancelModalProps {
    open: boolean,
    onYes: () => void
    onNo: () => void
    onCloseIcon: () => void
    CompanyName: string;
}

const ConfirmCancelModal = (props: ConfirmCancelModalProps) => {
    const { open, onYes, onNo, onCloseIcon, CompanyName } = props
    const isOnMobileScreen = useMediaQuery("(max-width:600px)");
    const style = {
        height: isOnMobileScreen ? "100%" : "560px",
    };
    return (
        <Dialog
            open={open}
            fullScreen={isOnMobileScreen}
            BackdropProps={{
                invisible: true,
            }}
            fullWidth={true}
            disableEnforceFocus
            style={{
                background: "none",
            }}
            PaperProps={{
                style: {
                    pointerEvents: "auto",
                    borderRadius: isOnMobileScreen ? "0px" : "24px",
                    width: isOnMobileScreen ? "100%" : "472px",
                    boxShadow: "none",
                    overflow: "hidden"
                },
            }}
            disableEscapeKeyDown={true}
        >
            <DialogContent>
                <Box sx={style}>
                    <Grid item display='flex' justifyContent='space-between' flexDirection='column' sx={{ height: '100%' }} >
                        <Grid item display="flex" flexDirection="column">
                            {isOnMobileScreen ?
                                <Grid item display='flex' justifyContent='center'>
                                    <Grid item display='flex' pl={4} sx={{ width: '340px' }}>
                                        <img src={WhiteInosio} style={{ width: "75px", height: "75px" }} alt="logo" />
                                        <Typography
                                            sx={{
                                                fontFamily: "Work Sans",
                                                fontStyle: 'normal',
                                                fontWeight: 700,
                                                fontSize: '18px',
                                                lineHeight: '23px',
                                                color: '#14142B',
                                                textAlign: 'left',
                                                padding: '15px'
                                            }}>
                                            {CompanyName}
                                        </Typography>
                                    </Grid>
                                </Grid>
                                : <></>}
                            <Grid item display='flex' justifyContent={isOnMobileScreen ? 'start' : 'center'}>
                                <Typography sx={{
                                    fontFamily: "Work Sans",
                                    fontStyle: 'normal',
                                    fontWeight: 700,
                                    fontSize: '18px',
                                    lineHeight: '23px',
                                    color: '#14142B',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    marginTop: '30px'
                                }}>
                                    Confirm Cancel
                                </Typography>
                            </Grid>

                            <Grid item display="flex" justifyContent='center' pb={3} pt={8}>
                                <img src={ConfirmationTick} alt='confirmation' />
                            </Grid>
                            <Grid item display="flex" flexDirection="column" alignItems='center' pt={6} >
                                <Typography
                                    sx={{
                                        fontFamily: "Work Sans",
                                        fontStyle: 'normal',
                                        fontWeight: 400,
                                        fontSize: '16px',
                                        lineHeight: '23px',
                                        color: '#14142B',
                                        textAlign: 'justify',
                                        marginTop: '10px'
                                    }}>
                                    Once cancelled the payment will drop off the card or bank statement in the next 24-48 hrs.
                                </Typography>
                                <Typography
                                    sx={{
                                        fontFamily: "Work Sans",
                                        fontStyle: 'normal',
                                        fontWeight: 400,
                                        fontSize: '16px',
                                        lineHeight: '23px',
                                        color: '#14142B',
                                        textAlign: 'justify',
                                        marginTop: '10px'
                                    }}>
                                    Are you sure you want to proceed?
                                </Typography>
                            </Grid>
                            <Grid item display='flex' pt={4} justifyContent='center'>
                                <Grid item>
                                    <Button variant="contained"
                                        style={{
                                            borderRadius: "24px",
                                            textTransform: "capitalize",
                                            color: "white",
                                            backgroundColor: "#A2DBFA",
                                            borderColor: "#39A2DB",
                                            height: '49',
                                            width: '99px',
                                        }} onClick={onYes}>
                                        Yes
                                    </Button>
                                </Grid>
                                <Grid item pl={1}>
                                    <Button variant="contained"
                                        style={{
                                            borderRadius: "24px",
                                            textTransform: "capitalize",
                                            color: "white",
                                            backgroundColor: "#39A2DB",
                                            borderColor: "#39A2DB",
                                            height: '49',
                                            width: '99px',

                                        }} onClick={onNo}>
                                        No
                                    </Button>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Box>
                <Grid item sx={{ position: 'absolute', top: isOnMobileScreen ? 123 : 45, right: 18 }}>
                    <img src={close} alt="back" style={{ cursor: 'pointer' }} onClick={onCloseIcon} />
                </Grid>
            </DialogContent >
        </Dialog >
        
    );
}

export default ConfirmCancelModal;

